import { Box, Button, Divider, Grid, TextField, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useState, useEffect, ChangeEvent } from 'react';
import { Remove, Add } from '@mui/icons-material';
import { AnaliseEstabilidade, InfoAnalises } from '../../../../services/api/reports/ReportsServicesRisr';
import { RISR } from '../../../../services/api/reports/ReportsServicesRisr';

interface AnalysisRiseProps {
    dataRisr?: RISR;
    onAnalysisChange: (data: AnaliseEstabilidade) => void;
}

export const AnalysisRisr = ({ dataRisr, onAnalysisChange }: AnalysisRiseProps) => {

    const theme = useTheme();
    const smDown = useMediaQuery(theme.breakpoints.down('sm'));

    const [data, setData] = useState<AnaliseEstabilidade>({
        informacoes: [],
        metodo_analise: '',
        modos_falha: ''
    });

    useEffect(() => {
        if (dataRisr?.analiseEstabilidade) {
            setData({
                ...dataRisr.analiseEstabilidade,
                informacoes: dataRisr.analiseEstabilidade.informacoes || []
            });
        }
    }, [dataRisr]);

    const handleAdd = () => {
        const newData = {
            ...data,
            informacoes: [...data.informacoes, {
                condicao: '',
                fator_seguranca: '',
                secao: '',
                valor_referencia: ''
            }],
        };
        setData(newData);
        onAnalysisChange(newData);
    };

    const handleRemove = (index: number) => {
        const newData = {
            ...data,
            informacoes: data.informacoes.filter((_, i) => i !== index),
        };
        setData(newData);
        onAnalysisChange(newData);
    };

    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        const { id, value } = e.target;
        const newData = {
            ...data,
            [id]: value,
        };
        setData(newData);
        onAnalysisChange(newData);
    };

    const handleAnomaliasChange = (index: number, fieldName: keyof InfoAnalises, value: string) => {
        const updatedInformacoes = [...data.informacoes];
        updatedInformacoes[index] = {
            ...updatedInformacoes[index],
            [fieldName]: value
        };

        const newData = {
            ...data,
            informacoes: updatedInformacoes
        };

        setData(newData);
        onAnalysisChange(newData);
    };

    return (
        <Box>
            <Box>
                <Grid container marginBottom={2}>
                    <Grid item xs={12}>
                        <Typography variant='h5'>Análises de estabilidade</Typography>
                        <Divider />
                    </Grid>
                </Grid>
                <Grid container spacing={2}>
                    <Grid item xs={smDown ? 12 : 6}>
                        <TextField
                            InputLabelProps={{ shrink: true }}
                            label='Modos de falha considerados'
                            value={data.modos_falha || ''}
                            id='modos_falha'
                            fullWidth
                            multiline
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={smDown ? 12 : 6}>
                        <TextField
                            InputLabelProps={{ shrink: true }}
                            label='Método de Análise (principal)'
                            value={data.metodo_analise || ''}
                            id='metodo_analise'
                            fullWidth
                            multiline
                            onChange={handleChange}
                        />
                    </Grid>
                </Grid>
                <Grid container marginBottom={2} marginTop={2}>
                    <Grid item xs={12}>
                        <Typography variant='h5'>Materiais e parâmetros</Typography>
                        <Divider />
                    </Grid>
                </Grid>
                <Grid container justifyContent={'center'}>
                    <Grid item xs={smDown ? 12 : 6} display="flex" justifyContent="center">
                        <Button
                            startIcon={<Remove />}
                            onClick={() => handleRemove(data.informacoes.length - 1)}
                            disabled={data.informacoes.length === 0}
                        >
                            Remover
                        </Button>
                    </Grid>
                    <Grid item xs={smDown ? 12 : 6} display="flex" justifyContent="center">
                        <Button
                            startIcon={<Add />}
                            onClick={handleAdd}
                        >
                            Adicionar
                        </Button>
                    </Grid>
                </Grid>
                {data.informacoes && data.informacoes.length > 0 && data.informacoes.map((item, index) => (
                    <Box key={index} padding={1}>
                        <Grid container spacing={2}>
                            <Grid item xs={smDown ? 12 : 6}>
                                <TextField
                                    InputLabelProps={{ shrink: true }}
                                    label='Seção'
                                    id='secao'
                                    fullWidth
                                    value={item?.secao || ''}
                                    onChange={(e) => handleAnomaliasChange(index, 'secao', e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={smDown ? 12 : 6}>
                                <TextField
                                    InputLabelProps={{ shrink: true }}
                                    label='Condição'
                                    id='condicao'
                                    fullWidth
                                    value={item?.condicao || ''}
                                    onChange={(e) => handleAnomaliasChange(index, 'condicao', e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={smDown ? 12 : 6}>
                                <TextField
                                    InputLabelProps={{ shrink: true }}
                                    label='Fator de Segurança'
                                    id='fator_seguranca'
                                    fullWidth
                                    value={item?.fator_seguranca || ''}
                                    onChange={(e) => handleAnomaliasChange(index, 'fator_seguranca', e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={smDown ? 12 : 6}>
                                <TextField
                                    InputLabelProps={{ shrink: true }}
                                    label='Valor de Referência'
                                    id='valor_referencia'
                                    fullWidth
                                    value={item?.valor_referencia || ''}
                                    onChange={(e) => handleAnomaliasChange(index, 'valor_referencia', e.target.value)}
                                />
                            </Grid>
                        </Grid>
                    </Box>
                ))}
            </Box>
        </Box>
    );
};